import { SrIcon } from "@/components/ui/SrIcon";
import type { Offer } from "@/hooks/use-offers";

interface Props {
  offer: Pick<Offer, "status" | "lost_reason">;
}

/**
 * VIB-1304 (Erik 15.07, smoke-test-fiks A4): LostReasonDialog krever en
 * begrunnelse ved statusendring til "lost", men begrunnelsen ble aldri
 * presentert etterpå — verken i editoren eller på boardet. Spec: «Begrunnelsen
 * vises på tilbudet». Dette er "på tilbudet"-visningen (editoren); board-
 * visningen (Tapt-bøtta) dekkes av OfferBoardCard.
 *
 * Rendres kun når status faktisk er "lost" OG en begrunnelse finnes — med
 * feature_offer_pipeline av kan lost_reason aldri være satt (buildStatusPatch
 * setter den kun når pipelineFields=true), så denne no-op-er naturlig bak
 * flagget uten egen gating her. Kalleren (OfferEditPage) gater likevel
 * eksplisitt på pipelineEnabled for å følge filens etablerte konvensjon.
 */
export function OfferLostReasonBanner({ offer }: Props) {
  if (offer.status !== "lost" || !offer.lost_reason) return null;

  return (
    <div className="mb-3 flex items-start gap-2 rounded-md border border-destructive/30 bg-destructive/5 px-3 py-2 text-sm text-destructive">
      <SrIcon name="circle-x" className="mt-0.5 h-4 w-4 shrink-0" />
      <p>
        <span className="font-medium">Tapt: </span>
        {offer.lost_reason}
      </p>
    </div>
  );
}
